import moment from 'moment';
import { EnumDispatchState } from '../../../oData';
import { DatePeriod } from '../../../../model';
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey';
import {
  BalanceZoneStoreModel,
  CompanyStoreModel,
  getAppConfigurationValue
} from '../../../../redux';
import AxiosInstance from '../../../http-config';
import { DispatchesByIdsRequest } from '../../model/Dispatches';
import { Dispatch } from '../../../oData/model';
import { DispatchRequest } from '../../../oData/requests/dispatch.request';

export const apiDispatchesGET = async (
  datePeriod: DatePeriod,
  balanceZone: BalanceZoneStoreModel | undefined,
  company: CompanyStoreModel | undefined
): Promise<Dispatch[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer);

  const parseStartDate = moment(datePeriod.start).format('YYYY-MM-DD');
  const parseEndDate = moment(datePeriod.end).format('YYYY-MM-DD');

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Dispatches/GetDispatchesByDates?startDate=${parseStartDate}&endDate=${parseEndDate}&company=${company?.id!}&balanceZone=${balanceZone?.id!}`
  ).then(response => {
    return response.data;
  });
};

export const apiDispatchesGETById = async (ids: number[], desiredStates: EnumDispatchState[]): Promise<Array<Dispatch>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer);

  const request: DispatchesByIdsRequest = {
    ids: ids,
    desiredStates: desiredStates
  }

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Dispatches/FetchDispatchesCheckedByState`, request
  ).then(response => {
    return response.data;
  });
};

export const apiMassiveDispatchesPOST = async (request: DispatchRequest): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer);

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Dispatches/MassiveDispatches`, request).then(
    response => {
      return response.status;
    }
  );
};
